/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import Confirmation from './Confirmation/index'
import DataVaxiomPatientInsuranceAssignForm from 'DesignSystem/DataVaxiomPatientInsuranceAssignForm/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/NewProfile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/Subscription/Content/Subscription/Content"
  
}) {
let assignedInsuranceInsuranceSubscriptionInsurancePlanIdValueData = fromData.useDataValue({ viewPath,
context: 'assigned_insurance',
path: 'insurance_subscription.insurance_plan._id',
})
let globalCurrentLocationPermissionsHasPatientInsuranceEditValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'current_location.permissions.has_patient_insurance_edit',
format: fromFormat.not,
})
  return (<React.Fragment
>
<DataVaxiomPatientInsuranceAssignForm
  viewPath={`${viewPath}/DataVaxiomPatientInsuranceAssignForm`}
 data="assigned_insurance.insurance_subscription.insurance_plan._id"
 insuranceId={assignedInsuranceInsuranceSubscriptionInsurancePlanIdValueData}
 data="global.current_location.permissions.has_patient_insurance_edit"
 format="/Data/format.js not"
 onlyCoverage={globalCurrentLocationPermissionsHasPatientInsuranceEditValueData}
/>
<Confirmation
  viewPath={`${viewPath}/Confirmation`}
/>
{children}
</React.Fragment>)
}